import React from 'react'

const Call = ({
  size,
  style,
  primaryColor,
  secondaryColor,
  title = 'icon/call',
  ...props
}) => (
  <svg height='20' width='20' viewBox='0 0 20 20' style={style} {...props}>
    <g fill='none' fillRule='evenodd'>
      <path
        d='M15.56 19h-.31C7.392 19 1 12.608 1 4.75v-.31l3-3 4.81 4.81L6.56 8.5l4.94 4.94 2.25-2.25L18.56 16l-3 3z'
        stroke={primaryColor}
        strokeWidth='1.2'
      />
      <path
        d='M19 8.5C19 4.364 15.636 1 11.5 1h-.75v1.5h.75c3.308 0 6 2.692 6 6v.75H19V8.5z'
        fill={secondaryColor}
      />
      <path
        d='M16 8.5C16 6.018 13.982 4 11.5 4h-.75v1.5h.75c1.655 0 3 1.346 3 3v.75H16V8.5z'
        fill={secondaryColor}
      />
    </g>
  </svg>
)

export default Call
